import { UseQueryResult, useQuery } from "@tanstack/react-query";
import { Project } from "@api";
import { AxiosError } from "axios";
import useApi from "@helpers/hooks/useApi";
import { ListResponse, QueryConfig } from "./queryUtils";

type ProjectListProps = {
  keyword?: string;
  limit?: number;
  offset?: number;
  isBookmark?: boolean;
};

export function useProjectList(
  { keyword, limit, offset, isBookmark }: ProjectListProps,
  queryConfig?: QueryConfig,
): UseQueryResult<ListResponse<Project>, AxiosError["response"]> {
  const api = useApi();

  return useQuery({
    ...queryConfig,
    queryKey: ["projects/list", { keyword, limit, offset, isBookmark }],
    queryFn: async () => {
      const res = await api.apiV1ProjectsList(
        "true" /** isActive */,
        keyword,
        isBookmark ? "true" : undefined,
        limit,
        offset,
      );
      return res.data;
    },
  });
}

export function useProject(
  { id }: { id: string },
  queryConfig?: QueryConfig,
): UseQueryResult<Project, AxiosError["response"]> {
  const api = useApi();

  return useQuery({
    ...queryConfig,
    queryKey: ["projects/get", { id }],
    queryFn: async () => {
      const res = await api.apiV1ProjectsRead(id);
      return res.data;
    },
  });
}
